export default __webpack_public_path__ + "static/media/bg4.80b9a1f0.jpg";